import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import almaLogo from "../../almanews_logo.svg";
import ConditionalRender from '../../ConditionalRender';
import { SuggestionBox } from '../../design_system/components/Input Fields/SuggestionBox.jsx';
import { Icons } from '../../design_system/components/Icons/Icons';
import { useSelector } from 'react-redux';

const SmallLoginHeader = () => {
    const [headerState, setHeaderState] = useState({ displaySearchBar: false });
    const _history = useHistory();
    const homePath = useSelector(state => state.current_team.team?.home_path) || "/feed";

    const handleRedirectToProspectShow = (name, val) => {
        if (val?.id) _history.push(`/prospects/${val.id}`);
    };

    const toggleSearchBar = () => setHeaderState(s => ({ ...s, displaySearchBar: !s.displaySearchBar }));

    if (headerState.displaySearchBar) return (
        <div className="header-mobile-overlay">
            <div className="header flex items-center">
                <span className="icon-container" onClick={toggleSearchBar}>
                    <Icons name="chevron-left" size={24} />
                </span>
                <div className="header-mobile-search">
                    <SuggestionBox
                        showIcon={true}
                        IconName="search"
                        suggestionUrl="/prospects/search"
                        params={{ team_search: true }}
                        placeholder="Search Prospects"
                        onSelect={handleRedirectToProspectShow}
                        Size="Large"
                    />
                </div>
            </div>
        </div>
    );

    return (
        <div className="header">
            <div className="relative flex-between header-inner--full-height">
                <Link to={homePath}>
                    <img src={almaLogo} className="header-logo" />
                </Link>
                <span className="icon-container" onClick={toggleSearchBar}>
                    <Icons name="search" size={24} />
                </span>
            </div>
        </div>
    );
};

export default SmallLoginHeader;
